/**
 * Suturia brand mark — open book with scalpel as pen.
 * Theme marks: sage on light, light-ink on dark. Prefer WebP; PNG fallback.
 */
import { cn } from '@/lib/utils';

interface BrandSealProps {
  className?: string;
  /** Accessible label; omit when decorative (parent link already names home). */
  title?: string;
  /**
   * Force a specific asset:
   * - `auto` (default): light/dark via CSS
   * - `onDark`: white mark for accent/FAB surfaces
   */
  variant?: 'auto' | 'onDark';
  /** Hero LCP mark — bump download priority (landing only). */
  fetchPriority?: 'high' | 'low' | 'auto';
}

export function BrandSeal({
  className,
  title,
  variant = 'auto',
  fetchPriority,
}: BrandSealProps) {
  if (variant === 'onDark') {
    return (
      <picture className={cn('inline-grid shrink-0', className)}>
        <source srcSet="/logo-on-dark.webp" type="image/webp" />
        <img
          src="/logo-on-dark.png"
          alt={title ?? ''}
          width={80}
          height={80}
          draggable={false}
          aria-hidden={title ? undefined : true}
          className="h-full w-full object-contain"
          fetchPriority={fetchPriority}
        />
      </picture>
    );
  }

  return (
    <span className={cn('relative inline-grid shrink-0', className)}>
      <picture className="col-start-1 row-start-1 dark:hidden">
        <source srcSet="/logo-light.webp" type="image/webp" />
        <img
          src="/logo-light.png"
          alt={title ?? ''}
          width={80}
          height={80}
          draggable={false}
          aria-hidden={title ? undefined : true}
          className="h-full w-full object-contain"
          fetchPriority={fetchPriority}
        />
      </picture>
      <picture className="col-start-1 row-start-1 hidden dark:block">
        <source srcSet="/logo-dark.webp" type="image/webp" />
        <img
          src="/logo-dark.png"
          alt=""
          width={80}
          height={80}
          draggable={false}
          aria-hidden
          className="h-full w-full object-contain"
        />
      </picture>
    </span>
  );
}
